<template>
    <div id="new_driver_commission_report" class="ui segment">
        <h1 class="ui header">
            <!-- 收派件提成報告 -->
            {{ $t('ui.page_titles.new_driver_commission_report') }}
            <div class="sub header">
                <button class="ui basic positive button" @click.prevent="start">
                    {{ $t('ui.pages.driver_commission_reports.start_all') }}
                </button>
            </div>
        </h1>
        <div v-if="status != 'before_initialized'">
            <form class="ui form">
                <div class="field" :class="{ disabled: status == 'locked' }">
                    <label>{{ $t('models.attributes.driver_commission_reports.staff') }}</label>
                    <select multiple="" class="ui dropdown" v-dropdown v-model="selected_driver_identities">
                        <option v-for="staff in staffs" :staff="staff" :value="staff.identity">{{ staff.name }}</option>
                    </select>
                </div>
                <div class="field" :class="{ disabled: status == 'locked' }">
                    <label>{{ $t('models.attributes.driver_commission_reports.begin_at') }}</label>
                    <el-date-picker
                        v-model="general_params.begin_at"
                        type="datetime"
                        :placeholder="$t('ui.el.datepicker.selectDateTime')">
                    </el-date-picker>
                </div>
                <div class="field" :class="{ disabled: status == 'locked' }">
                    <label>{{ $t('models.attributes.driver_commission_reports.end_at') }}</label>
                    <el-date-picker
                        v-model="general_params.end_at"
                        type="datetime"
                        :placeholder="$t('ui.el.datepicker.selectDateTime')">
                    </el-date-picker>
                </div>
            </form>

            <table class="ui celled table">
                <thead>
                    <tr class="center aligned">
                        <th>{{ $t('models.attributes.driver_commission_reports.staff') }}</th>
                        <th>{{ $t('models.attributes.driver_commission_reports.begin_at') }}</th>
                        <th>{{ $t('models.attributes.driver_commission_reports.end_at') }}</th>
                        <th>{{ $t('ui.pages.driver_commission_reports.status') }}</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <Item
                        v-for="driver in selected_drivers"
                        :key="driver.identity"
                        :driver="driver"
                        :begin_at="$moment(general_params.begin_at).format('YYYY-MM-DDTHH:mm:ss+08:00')"
                        :end_at="$moment(general_params.end_at).format('YYYY-MM-DDTHH:mm:ss+08:00')"
                    ></Item>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
import Item from "../.components/new/item.vue"
export default {
    name: "NewDriverCommissionReport",
    props: {
    },
    data() {
        return {
            status: "before_initialized",
            staffs: [],
            selected_driver_identities: [],
            selected_drivers: [],
            general_params: {},
            errors: [],
        }
    },
    created() {
        this.init()
    },
    mounted() {
    },
    watch: {
        '$route' (to, from) {
            if (to.name == "new_driver_commission_report") {
                this.init()
            }
        },
        'selected_driver_identities' (to, from) {
            this.selected_drivers = []
            this.selected_drivers = _.filter(this.staffs, staff => {
                return this.selected_driver_identities.includes(staff.identity)
            })
        },
    },
    computed: {
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.general_params = {
                    begin_at: "",
                    end_at: "",
                }
                this.errors = []
                resolve()
            })
            await this.fetch_staffs()
            await new Promise(resolve => {
                this.status = "initialized"
                resolve()
            })
        },
        fetch_staffs() {
            var url = new RestUrl(this.$store.state.provider.routes.api_v1_provider_staffs).parse(
                {},
                "?" + object_to_query({
                    pagination: false,
                })
            )

            return axios.get(url, {headers: { Authorization: localStorage.getItem("authentication_token") }})
                .then(response => {
                    if (response.data.status == "success") {
                        this.staffs = response.data.staffs
                    } else {
                        // this.$noty.error('無法取得staffs 員工列表')
                        this.$noty.error(
                            this.$t('ui.notifications.error.fetch__name', {
                                name: this.$t('models.staffs')
                            })
                        )
                    }
                })
                .catch(error => {
                    // this.$noty.error('取得staffs失敗')
                    this.$noty.error(
                        this.$t('ui.notifications.error.fetch__name', {
                            name: this.$t('models.staffs'),
                            reason: ': ' + errors
                        })
                    )
                })
        },
        async start() {
            if (this.selected_drivers.length > 0) {
                if (this.general_params.begin_at && this.general_params.end_at) {
                    this.status = "locked"
                    for (let item of this.$children) {
                        if (item.driver) {
                            var url = this.$store.state.provider.routes.api_v1_provider_driver_commission_reports_create
                            var params = {
                                staff_identity: item.driver.identity,
                                begin_at: this.$moment(this.general_params.begin_at).format('YYYY-MM-DDTHH:mm:ss+08:00'),
                                end_at: this.$moment(this.general_params.end_at).format('YYYY-MM-DDTHH:mm:ss+08:00')
                            }
                            await this.create(url, params, item)
                        }
                    }
                } else {
                    this.$noty.error(
                        this.$t('ui.general.please_select') +
                        " 起訖日"
                    )
                }
            } else {
                this.$noty.error(
                    this.$t('ui.general.please_select') +
                    " 對象"
                )
            }
        },
        create(url, params, component) {
            if (component.status != "done" && component.status != "canceled") {
                component.status = "processing"
                return axios.post(url, params, { headers: { Authorization: localStorage.getItem("authentication_token") }}).then(response => {
                    if (response.data.status == "success") {
                        component.status = "done"
                        component.report_identity = response.data.driver_commission_report.identity
                    } else {
                        component.status = "failed"
                    }
                })
                .catch(error => {
                    component.status = "failed"
                })
            }
        },
    },
    components: {
        Item
    }
}
</script>
<style>
    #new_driver_commission_report .el-input__inner {
        padding-left: 30px !important;
    }
</style>

<style scoped>
</style>
